// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__hqDBJ","value":"style_value__Lp7lk","noIcon":"style_no-icon__ZCXFE"};